import React from 'react';
import { css } from 'styled-components';

import { mergeClassNames } from 'utils/functions';

const progressCss = css`
    .progress-bar.progress-success {
        background-color: ${p => p.theme.color.success} !important;
    }
    .progress-bar.progress-warning {
        background-color: ${p => p.theme.color.orange} !important;
    }
    .progress-bar.progress-primary {
        background-color: ${p => p.theme.color.primary} !important;
    }
    .progress-bar.progress-danger {
        background-color: ${p => p.theme.color.danger} !important;
    }
`;

export const ProgressBar = ({
    now = 100,
    flavor = 'success',
    striped = false,
    active = false,
    label = '',
    className = '',
    ...domProps
}) => {
    return (
        <div className={mergeClassNames(className, 'progress')} css={progressCss} {...domProps}>
            <div
                className={`progress-bar${
                    striped ? ' progress-bar-striped ' : ' '
                }progress-${flavor}`}
                role='progressbar'
                style={{ width: `${now}%` }}
                aria-valuenow={now}
                aria-valuemin='0'
                aria-valuemax='100'
            >
                {label}
            </div>
        </div>
    );
};

export default ProgressBar;
